module.exports = __webpack_public_path__ + "img/202308_04.e10822dc.jpg";